import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `PanelControl/guardarPanelControl`, method: 'POST', body: values, token: token})
}
